module.exports = __webpack_public_path__ + "static/media/promotion_from_45_to_49.648f1a16.webp";